<template>
  <div>
    <div>
      <div class="log-header">
        <div class="log-container">
          <div class="brand">
            <img
              :src="brand"
              alt=""
            >
          </div>
          <div class="log-welcome">
            营销中心
          </div>
        </div>
      </div>
      <router-view />
    </div>
    <div class="log-footer">
      <span>友情链接：</span>
      <a
        href="https://mp.weixin.qq.com/cgi-bin/loginpage?t=wxm2-login&lang=zh_CN"
        target="_blank"
      >微信公众平台</a>
      <span>|</span>
      <a
        href="https://www.alipay.com/"
        target="_blank"
      >支付宝</a>
      <span>|</span>
      <a
        href="http://e.qq.com/ads"
        target="_blank"
      >腾讯社交广告</a>
    </div>
    <div class="beian">
      <div>
        <a
          target="_blank"
          href="http://beian.miit.gov.cn/"
        >
          <span v-if="status === 'dev'">沪ICP备05002918号-10</span>
          <span v-else>沪ICP备05002918号-19</span>
        </a>
      </div>
      <div class="gongan-beian">
        <img
          src="@/assets/img/gongan-beian.png"
          alt=""
        >
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402000102"
        >
          沪公网安备 31010402000102号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Entry from '@/entry'
export default {
  name: 'AuthLayout',
  data () {
    const system = process.env.VUE_APP_PRODUCT_MODEL
    const brand = require(`@/assets/img/${system}/logo.jpg`)
    const login_bg = require(`@/assets/img/${system}/login_bg.jpg`)
    return {
      bool: false,
      brand,
      status: process.env.VUE_APP_STATUS
    }
  },
  watch: {},
  created () {
    const Entry1 = new Entry({ url: location.href, ctx: this })
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
body {
  background: #eaeaea;
}
.log-header {
  padding: 20px 0;
  background: #fff;
}
.brand {
  display: inline-block;
  width: 150px;
  vertical-align: middle;
}
.brand img {
  width: 100%;
  height: auto;
}
.log-welcome {
  display: inline-block;
  padding-left: 24px;
  margin-left: 24px;
  border-left: 1px solid #efefef;
  vertical-align: middle;
  font-size: 26px;
}
.log-body {
  padding: 118px 0;
  // background: url(/static/img/login_bg.jpg) no-repeat center center;
  background-size: cover;
}
.log-img {
  float: left;
  width: 360px;
  padding-top: 5px;
  padding-left: 50px;
}
.log-img img {
  width: 100%;
  height: auto;
}
.log-container {
  width: 900px;
  margin: 0 auto;
}
.log-container::after {
  display: table;
  clear: both;
  content: '';
}
.login-log-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02)*/
  float: right;
  padding-top: 20px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  width: 290px;
  padding: 0px 35px 15px 35px;
  background: #fff;
  //border: 1px solid #eaeaea;
  .title {
    margin: 0px auto 35px auto;
    text-align: center;
    color: #505458;
    position: relative;
    font-size: 18px;
  }
  .remember {
    // margin: 0px 0px 35px 0px;
    float: left;
  }
  .log-opr {
    margin-bottom: 10px;
    margin-right: 10px;
  }
  .signup {
    color: #ff5000;
    font-size: 14px;
    position: absolute;
    right: 0;
    line-height: 27px;
    &:hover {
      text-decoration: underline;
    }
  }
  .forget-pwd {
    float: right;
    &:hover {
      text-decoration: underline;
    }
  }
}
.el-form-item {
  margin-bottom: 30px;
}
.log-footer {
  color: #999;
  text-align: center;
  padding: 30px 0 10px 0;
  a {
    color: #999;
    margin: 0 5px;
    &:hover {
      color: #ff5000;
    }
  }
}
.login-type-tab {
  float: right;
  .login-type-tab-iframe {
    width: 100%;
    height: 320px;
  }
}
.beian {
  padding: 10px 0 30px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;

  a {
    color: #909399;
  }

  .gongan-beian {
    display: flex;
    align-items: center;
    height: 100%;
    img {
      width: 20px;
      height: 20px;
      margin: 0 2px 0 20px;
    }
  }
}
</style>
<style lang="scss">
.log-body {
  .el-input {
    .el-input__inner {
      height: 38px;
    }
  }
}
</style>
